<section *ngIf="!isSkeletonLoading" class="contact-us-with-support" id="contact-us">
  <div class="box">
    <div class="box-left">
      <h2 class="box-left__title"
        ><span>{{ 'CONTACT_US_WITH_SUPPORT.TITLE' | translate }}</span></h2
      >
      <div class="box-left__detail">
        <div class="box-left__detail--content">
          <span>{{ 'CONTACT_US_WITH_SUPPORT.DETAIL' | translate }}</span></div
        >
        <div class="box-left__detail--communicate">
          <div class="communicate-support" *ngFor="let item of contactDetails">
            <i [ngClass]="item.icon"></i
            ><a
              class="communicate-support__layout"
              [href]="item.link"
              [target]="item.target"
              (click)="trackGrowthBookMetric(UserAnalyticEvents.ContactSection, item.key)"
              rel="noopener noreferrer"
              ><span>{{ item.info }}</span></a
            >
          </div>
        </div>
        <div class="box-left__detail--chat"
          ><div class="chat-text"
            ><span>{{ 'CONTACT_US_WITH_SUPPORT.CHAT' | translate }}</span></div
          >
          <a *ngFor="let item of chatLinks" [ngClass]="item.class" [href]="item.link" target="_blank">
            <img [src]="item.image" [alt]="item.class" />
          </a>
        </div>
      </div>
    </div>
    <div class="box-right">
      <div class="box-right__img">
        <picture>
          <source srcset="https://flowaccountcdn.com/new_landing/image/home/Support-v2.webp" type="image/webp" />
          <img
            src="https://flowaccountcdn.com/new_landing/image/home/Support-v2.png"
            class="img-layout"
            alt="support-flowaccount"
            loading="lazy"
          />
        </picture>
      </div>
    </div>
  </div>
</section>

<ng-container *ngIf="isSkeletonLoading">
  <flowaccount-skeleton-loader-intro
    [customCount]="skeletonCustomCount"
    [customStyle]="'contact-support'"
  ></flowaccount-skeleton-loader-intro>
</ng-container>
